module.exports = function(h, row) {
    if (row.mode == 0) {
        return 'After order amount';
    }
    if (row.mode == 1) {
        return 'Before sub total amount';
    }
    if (row.mode == 2) {
        return 'Before final amount';
    }
};



// WEBPACK FOOTER //
// ./resources/assets/js/franchise_component/inventory/charge/mode.jsx